"use strict";
/* eslint-disable no-useless-constructor */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstanceCollector = void 0;
const events_typed_1 = require("@video/events-typed");
class InstanceCollector extends events_typed_1.EventEmitter {
    constructor(options) {
        super();
        this.options = options;
        this.objects = new Map();
        this.metas = new WeakMap();
        this.isDisposed = false;
        InstanceCollector.instances.add(this);
        for (const type of options.classes) {
            this.objects.set(type, new Set());
        }
    }
    doesCollect(type) {
        return this.options.classes.includes(type);
    }
    insertObject(type, object, meta) {
        this.objects.get(type).add(object);
        if (meta != null) {
            this.metas.set(object, meta);
        }
        if (object instanceof events_typed_1.EventEmitter) {
            object.once("disposed", () => this.objects.get(type).delete(object));
        }
    }
    removeObject(type, object) {
        var _a;
        (_a = this.objects.get(type)) === null || _a === void 0 ? void 0 : _a.delete(object);
        this.metas.delete(object);
    }
    static reportNewInstance(type, object, meta) {
        for (const collector of InstanceCollector.instances.values()) {
            if (collector.doesCollect(type)) {
                collector.insertObject(type, object, meta);
            }
        }
    }
    static disposeInstance(type, object) {
        for (const collector of InstanceCollector.instances.values()) {
            collector.removeObject(type, object);
        }
    }
    getObjects(type) {
        if (!this.objects.has(type)) {
            return [];
        }
        return Array.from(this.objects.get(type).values()).map((v) => {
            var _a;
            return [v, (_a = this.metas.get(v)) !== null && _a !== void 0 ? _a : {}];
        });
    }
    dispose(reason) {
        this.isDisposed = true;
        InstanceCollector.instances.delete(this);
        this.emit("disposed");
    }
}
exports.InstanceCollector = InstanceCollector;
InstanceCollector.instances = new Set();
if (typeof global === "object" && global != null) {
    global._VDC_InstanceCollector = InstanceCollector;
}
//# sourceMappingURL=instance-collector.js.map